<template>
    <div class="button__content">
        <button class="button__betslip" @click="handleClickOpenBetSlip">
            {{ getTranslatedText(`betslip`) }}
            <span class="button__betslip--number badge" v-if="getBetslips.length > 0">
                {{ getBetslips.length }}
            </span>
        </button>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import languageMixins from "@/mixins/language/language-mixins";
import EventBus from "@/utils/EventBus";

export default {
    mixins: [languageMixins],
    computed: {
        ...mapGetters(["getBetslips"]),
    },
    methods: {
        handleClickOpenBetSlip() {
            EventBus.$emit("open-betslip", false);
        },
    },
};
</script>

<style lang="scss">
@import "@/public/scss/components/common/button_betslip.scss";
</style>
